import React, { useState } from 'react';

import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';

import {
  FilterContainer,
  FilterHeader,
  FilterSection,
  FilterCategory,
  FilterFooter,
} from './styles';

const DATE_OPTIONS = [
  { value: 7, label: 'Últimos 7 dias' },
  { value: 30, label: 'Último mês' },
  { value: 90, label: 'Últimos 3 meses' },
  { value: 180, label: 'Últimos 6 meses' },
  { value: 365, label: 'Último ano' },
];

export default function FilterMenu({
  handleClear,
  handleApply,
  setFilterOpen,
}) {
  const theme = useTheme();

  const [selectedCategory, setSelectedCategory] = useState('read');
  const [read, setRead] = useState('');
  const [date, setDate] = useState('');
  const [order, setOrder] = useState('');

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const renderFilterOptions = () => {
    switch (selectedCategory) {
      case 'read':
        return (
          <RadioGroup
            value={read}
            onChange={({ target }) => setRead(target.value)}
          >
            <FormControlLabel
              value="not read"
              control={<Radio />}
              label="Não lidas"
            />
            <FormControlLabel value="read" control={<Radio />} label="Lidas" />
          </RadioGroup>
        );
      case 'date':
        return (
          <RadioGroup
            value={date}
            onChange={({ target }) => setDate(target.value)}
          >
            {DATE_OPTIONS.map(({ value, label }) => (
              <FormControlLabel
                key={label}
                value={value}
                control={<Radio />}
                label={label}
              />
            ))}
          </RadioGroup>
        );
      case 'order':
        return (
          <RadioGroup
            value={order}
            onChange={({ target }) => setOrder(target.value)}
          >
            <FormControlLabel
              value="earlier"
              control={<Radio />}
              label="Mais recente"
            />
            <FormControlLabel
              value="later"
              control={<Radio />}
              label="Mais antigo"
            />
          </RadioGroup>
        );
      default:
        return null;
    }
  };

  return (
    <FilterContainer elevation={4}>
      <FilterHeader>
        <Typography variant="h2">Filtros</Typography>
        <Box display="flex" alignItems="center">
          <Typography
            variant="h4"
            color="error"
            sx={{ cursor: 'pointer', fontWeight: 600 }}
            onClick={handleClear}
          >
            Limpar
          </Typography>
        </Box>
      </FilterHeader>

      <Divider />

      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            width: '140px',
            borderRight: `1px solid ${theme.palette.divider}`,
          }}
        >
          <FilterSection>
            <FilterCategory
              variant="body1"
              sx={{
                cursor: 'pointer',
                fontWeight: selectedCategory === 'read' ? 600 : 400,
                backgroundColor:
                  selectedCategory === 'read'
                    ? theme.palette.action.hover
                    : 'inherit',
              }}
              onClick={() => handleCategoryClick('read')}
            >
              Status
            </FilterCategory>
            <FilterCategory
              variant="body1"
              sx={{
                cursor: 'pointer',
                fontWeight: selectedCategory === 'date' ? 600 : 400,
                backgroundColor:
                  selectedCategory === 'date'
                    ? theme.palette.action.hover
                    : 'inherit',
              }}
              onClick={() => handleCategoryClick('date')}
            >
              Data
            </FilterCategory>
            <FilterCategory
              variant="body1"
              sx={{
                cursor: 'pointer',
                fontWeight: selectedCategory === 'order' ? 600 : 400,
                backgroundColor:
                  selectedCategory === 'order'
                    ? theme.palette.action.hover
                    : 'inherit',
              }}
              onClick={() => handleCategoryClick('order')}
            >
              Ordenar
            </FilterCategory>
          </FilterSection>
        </Box>

        <Box sx={{ flex: 1 }}>
          <FilterSection>{renderFilterOptions()}</FilterSection>
        </Box>
      </Box>

      <Divider />

      <FilterFooter>
        <Button
          variant="outlined"
          onClick={() => setFilterOpen(false)}
          sx={{ textTransform: 'none' }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => handleApply(read, date, order)}
          sx={{ textTransform: 'none' }}
        >
          Aplicar
        </Button>
      </FilterFooter>
    </FilterContainer>
  );
}
